// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M9.5 10C9.5 8.61929 10.6193 7.5 12 7.5C13.3807 7.5 14.5 8.61929 14.5 10C14.5 11.3807 13.3807 12.5 12 12.5C10.6193 12.5 9.5 11.3807 9.5 10Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M3 10C3 13.4759 4.97025 16.4897 7.85195 17.9889L7.19473 21H5V23H19V21H16.8053L16.1481 17.9889C19.0298 16.4897 21 13.4759 21 10C21 5.02944 16.9706 1 12 1C7.02944 1 3 5.02944 3 10ZM9.74081 18.7138C10.4634 18.9007 11.2206 19 12 19C12.7794 19 13.5366 18.9007 14.2592 18.7138L14.7582 21H9.24181L9.74081 18.7138ZM7.5 10C7.5 7.51472 9.51472 5.5 12 5.5C14.4853 5.5 16.5 7.51472 16.5 10C16.5 12.4853 14.4853 14.5 12 14.5C9.51472 14.5 7.5 12.4853 7.5 10Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-camera-1-filled')
export default class Camera1FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'camera-1-filled',
    }
  }
}
